/* unplugin-vue-components disabled */import { render } from "./edit-modal.vue?vue&type=template&id=5afc251c&scoped=true"
import script from "./edit-modal.vue?vue&type=script&lang=js"
export * from "./edit-modal.vue?vue&type=script&lang=js"

import "./edit-modal.vue?vue&type=style&index=0&id=5afc251c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afc251c"],['__file',"src/pages/sh-contacts/edit-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5afc251c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5afc251c', __exports__)) {
    api.reload('5afc251c', __exports__)
  }
  
  module.hot.accept("./edit-modal.vue?vue&type=template&id=5afc251c&scoped=true", () => {
    api.rerender('5afc251c', render)
  })

}


export default __exports__